import * as React from 'react';

import 'css!./__styles__/MessageCard';

const MessageCard: React.LegacyFunctionComponentWithChildren<{}> = ({ children }) => (
  <div className="rc-MessageCard">{children}</div>
);

export default MessageCard;
